import React, {useContext} from "react";
// @ts-ignore
import {useParams} from "react-router-dom";
import '../RankingsAndLevelsComponent/RankingsAndLevels.css'
import {RankingsAndLevelsContext} from "../../contexts/RankingsAndLevelsContext";
import TierIndexComponent from "./Components/TierIndexComponent";


const TierContainer: React.FC = () => {
    let { yearCode } = useParams();
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);

    return (
        <TierIndexComponent
            isLife={isLife}
            yearCode={yearCode}
        />
    )
};

export default TierContainer;